/* global attachEvent */

// *******************************************************************************
// Open Order Modal
// *******************************************************************************

attachEvent('.promotion-banner', 'click', (ev) => {
  const gaEventName = ev.target.closest('a').getAttribute('data-ga-event');
  if (window.gtag && gaEventName) {
    gtag('event', 'Promo banner', {
      event_category: 'Promotional banner',
      event_label: gaEventName,
    });
  }
});
